export default {
  props: ['photosView', 'fullscreen', 'setProducts', 'viewProduct'],
  computed: {
    allowOrder() {
      let photos = [];

      this.setProducts.forEach(product => {
        if (product.photo) {
          photos.push(product.photo);
        }
      });

      return this.setProducts.length === photos.length;
    }
  },
  methods: {
    next() {
      this.$store.dispatch('ADD_TO_CART');
      this.$store.dispatch('CLEAR_SET');
      this.$store.dispatch('DROP_ORDER');

      this.$router.push(this.i18nLink('cart'));
    },
    back() {
      if (this.viewProduct) {
        this.$emit('view-product', null);
      } else if (this.photosView) {
        this.$router.push({name: 'album', hash: '#set'});
        this.$store.dispatch('SET_REPLACED_PHOTO_PRODUCT', false);
      } else {
        this.closeOrderSet();
      }
    },
  },
};
